import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PolicyDetailsHeader from '../../Components/PolicyHolder/PolicyDetailsHeader';
import PolicyNav from '../../Components/PolicyHolder/PolicyNav';
import AccountValuesSection from '../../Components/PolicyHolder/AccountValuesSections/AccountValuesSection';
import OwnerInfoSection from '../../Components/PolicyHolder/OwnerInfoSection';
import AgentInfoSection from '../../Components/PolicyHolder/AgentInfoSection';
import WithdrawHistorySection from '../../Components/PolicyHolder/WithdrawHistorySection';
import ClaimsHistoryMedSupSection from '../../Components/PolicyHolder/ClaimsHistoryMedSupSection';
import ClaimsHistoryMajorMedSection from '../../Components/PolicyHolder/ClaimsHistoryMajorMedSection';
import SuppContractHistorySection from '../../Components/PolicyHolder/SuppContractHistorySection';
import BenefitsSection from '../../Components/PolicyHolder/BenefitsSection';
import PremiumHistorySection from '../../Components/PolicyHolder/PremiumHistorySection';
import IDCardSection from '../../Components/PolicyHolder/IDCardSection';
import BeneSection from '../../Components/PolicyHolder/BeneSection';
import CorrespondenceSection from '../../Components/PolicyHolder/CorrespondenceSection';
import IssuePacketSection from '../../Components/PolicyHolder/IssuePacketSection';
import AllocationsSection from '../../Components/PolicyHolder/AllocationsSection';
import PolicyServiceFormsSection from '../../Components/PolicyHolder/PolicyServiceFormsSection';
import UploadServiceFormsSection from '../../Components/Shared/UploadServiceFormSection.jsx';
import { useAuth } from "../../src/Context/AuthContext"

const PolicyDetailsPage = ({ portalSettings }) => {
    //State Variables
    const { polNo } = useParams();
    const [activeSection, setActiveSection] = useState('values-container');
    const [model, setModel] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { logout } = useAuth();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - ${polNo}`;

    useEffect(() => {
        const fetchPolicy = async () => {
            try {
                const res = await fetch(`${apiURL}/Policy/GetPolicy?policyNo=${polNo}`, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (res.status === 401) {
                    logout();
                    navigate('/login');
                    throw new Error("unauthorized");
                }

                if (res.status === 403) {
                    navigate('/home');
                    throw new Error("forbidden");
                }

                if (!res.ok) {
                    return;
                }
                const data = await res.json();

                setModel(data);
            } catch (error) {
                console.error('Error fetching policy:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPolicy();
    }, [polNo]);

    const handleNavClick = (section) => {
        setActiveSection(section);
        setTimeout(() => {
            const sectionElement = document.getElementById(section);
            if (sectionElement) {
                sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100); // slight delay to ensure DOM is updated
    };

    if (loading) return <div></div>;
    if (!model) return <div className="text-center mt-5 text-danger">Policy not found.</div>;

    return (
        <div className="PolicyDetailsPage">
            <PolicyDetailsHeader polNo={model.polNo} />
            <PolicyNav
                model={model}
                selectedSection={activeSection}
                onNavClick={handleNavClick}
            />

            {activeSection === 'values-container' && <AccountValuesSection model={model} portalSettings={portalSettings} />}
            {activeSection === 'owner-container' && <OwnerInfoSection model={model} />}
            {activeSection === 'agent-container' && <AgentInfoSection model={model} />}
            {activeSection === 'premium-history-container' && <PremiumHistorySection model={model} />}
            {activeSection === 'claims-history-container' && <WithdrawHistorySection model={model} />}
            {activeSection === 'claims-history-ms-container' && <ClaimsHistoryMedSupSection model={model} />}
            {activeSection === 'claims-history-mm-container' && <ClaimsHistoryMajorMedSection model={model} />}
            {activeSection === 'supp-contract-history-container' && <SuppContractHistorySection model={model} />}
            {activeSection === 'benefits-container' && <BenefitsSection model={model} />}
            {activeSection === 'id-card-container' && <IDCardSection model={model} portalSettings={portalSettings} />}
            {activeSection === 'allocations-container' && <AllocationsSection model={model} />}
            {activeSection === 'beneficiaries-container' && <BeneSection model={model} />}
            {activeSection === 'correspondence-container' && <CorrespondenceSection model={model} />}
            {activeSection === 'issue-packet-container' && <IssuePacketSection model={model} />}
            {activeSection === 'service-form-container' && <PolicyServiceFormsSection model={model} />}
            {activeSection === 'upload-form-container' && <UploadServiceFormsSection refNo={model.polNo} refNoType="POL"/>}

        </div>
    );
};

export default PolicyDetailsPage;
